import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import axiosClient from '../../../utils/axios';
import { resolve } from '../../../api/endPoints';

interface BestTimeToPostData {
  data: any;
  isLoading: boolean;
  error: string | null;
}

const initialState: BestTimeToPostData = {
  data: {},
  isLoading: false,
  error: null
};

const bestTimeToPostSlice = createSlice({
  name: 'bestTimeToPost',
  initialState,
  reducers: {
    startLoading: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    stopLoading: (state) => {
      state.isLoading = false;
    },
    setData: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.error = null;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    resetData: (state) => {
      state.data = [];
      state.error = null;
    }
  }
});

export default bestTimeToPostSlice.reducer;

export const { startLoading, stopLoading, setData, setError, resetData } = bestTimeToPostSlice.actions;

// Fetch best time to post data based on location uuid
export const fetchBestTimeToPost = (locationUuid: string) => {
  return async (dispatch: any) => {
    dispatch(startLoading());
    try {
      // Assuming you have an API endpoint for getting best time to post data
      const url = resolve('analytics_best_time_to_post', {}, { location__uuid: locationUuid });
      const response = await axiosClient.get(url);
      dispatch(setData(response.data?.results?.[0]?.data || {}));
      dispatch(stopLoading());
    } catch (error: any) {
      console.error('Error fetching best time to post data:', error);
      dispatch(setError(error.message || 'Failed to fetch best time to post data'));
    }
  };
};
